import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { useTranslation } from '@blocs.i18n';
import { FilterData } from '../../../shared/types';
import { FieldGroup, Delimiter, StyledFormikDatePicker } from '../../../shared/styles';

const StyledDelimiter = styled(Delimiter)`
  margin: 0 0.5rem;
`;

type Props = {
  dateRangeName: FilterData['name'];
  dateRangeMinName: FilterData['name'];
  dateRangeMaxName: FilterData['name'];
  label: FilterData['label'];
};

const getSelectedDate = ({ currentDateValue, otherDateValue }): Date => {
  if (currentDateValue) {
    return new Date(currentDateValue);
  }

  if (!currentDateValue && otherDateValue) {
    return new Date(otherDateValue);
  }

  return null;
};

const BookedOutDate: FC<Props> = ({ dateRangeName, dateRangeMinName, dateRangeMaxName, label }) => {
  const { t } = useTranslation();
  const formikContext = useFormikContext();

  const currentDate = new Date();
  const dateRangeMinValue = formikContext.values[dateRangeName][dateRangeMinName];
  const dateRangeMaxValue = formikContext.values[dateRangeName][dateRangeMaxName];

  return (
    <DropdownWithChildren isChildrensContentFilled={dateRangeMaxValue || dateRangeMinValue} toggleLabel={label}>
      <FieldGroup>
        <StyledFormikDatePicker
          name={`${dateRangeName}.${dateRangeMinName}`}
          selected={getSelectedDate({ currentDateValue: dateRangeMinValue, otherDateValue: dateRangeMaxValue })}
          minDate={currentDate}
          maxDate={dateRangeMaxValue ? new Date(dateRangeMaxValue) : null}
          dateFormat="short"
          isClearable={false}
          popperPlacement="bottom-end"
          label={t('common:filtersName.bookedOutDates.min')}
          labelVisible={false}
        />
        <StyledDelimiter>{t('common:filter.to')}</StyledDelimiter>
        <StyledFormikDatePicker
          name={`${dateRangeName}.${dateRangeMaxName}`}
          selected={getSelectedDate({ currentDateValue: dateRangeMaxValue, otherDateValue: dateRangeMinValue })}
          minDate={dateRangeMinValue ? new Date(dateRangeMinValue) : currentDate}
          dateFormat="short"
          isClearable={false}
          popperPlacement="bottom-end"
          label={t('common:filtersName.bookedOutDates.max')}
          labelVisible={false}
        />
      </FieldGroup>
    </DropdownWithChildren>
  );
};

export default memo(BookedOutDate);
